<template>
  <v-card class="item" :href="link" target="_blank" flat tile>
    <img class="d-block mx-auto item-img" :src="files + img" :alt="title" />
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    filter: grayscale(1);
    height: 90px;
    -o-object-fit: contain;
    object-fit: contain;
    opacity: 0.6;
    transition: all 0.1s linear;
    width: 70%;
  }

  &:hover {
    .item-img {
      filter: grayscale(0);
      opacity: 1;
    }
  }
}
</style>
